export default __webpack_public_path__ + "images/Quality_Picture_cut_v01.webp?6f4e2e748528f9b139e99731a752b865";